export const routes = (prefix = `theatre`) => [
    {
        path: `/${prefix}/procedure-queue`,
        name: `${prefix}.procedure-queue.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.procedure-queue.index`,
                PageDescription: "Theatre: Procedure Queue",
            },
        },
    },
];
